import {isDesktop} from 'app/utils';
import {APP_INSTALL_ASKED} from 'app/utils/Consts';
import {configStore} from 'app/store/global';

export const isShowAppNotification = ():boolean => !(localStorage.getItem(APP_INSTALL_ASKED) === 'true') &&
    !isDesktop() && !configStore.MOBILE_WRAPPER;
